import React from 'react';
import {
	CardContent,
	CardFooter as StyledCardFooter,
	CardHeader,
	Container,
	Dot,
	Tag,
} from './styles';
import {Divider, Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';
import {FavoriteDoctorsLikeButton} from 'presentation/modules/booking/favoriteDoctors/components/FavoriteDoctorsLikeButton';
import {InstructionsAlertInfo} from '../InstructionsAlertInfo';
import {formatText} from 'presentation/utils';
import {CardActions} from './components/CardActions';
import {useAppointmentCard} from '../../hooks/useAppointmentCard';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {NotredameAppointmentCardProps} from './types';
import {translations} from 'presentation/translations-new';
import {AttachmentCard} from '../../../UploadAttachmentCard';
import {AppointmentTeleTutorial} from '../AppointmentTeleTutorial';

const {teleHealth, exam, consultationTag} =
	translations['pt-br'].privateFlow.myAppointments.appointmentCard;
const {selectedProcedure} = translations['pt-br'].privateFlow.bookingFlow.examSelection;

export function NotredameAppointmentCard({
	hasFavoriteButton,
	id,
	isFavoriteButtonDisabled,
	appointment,
}: NotredameAppointmentCardProps) {
	const {
		isTelehealth,
		showEnterRoom,
		isOdonto,
		isUploadFileTeleFeatureFlagEnabled,
		hideFavoriteButton,
		clinicName,
		isAdvanceDiagnosticsExam,
	} = useAppointmentCard(appointment);

	let tagText = consultationTag;

	if (isTelehealth) {
		tagText = teleHealth.tag;
	} else if (appointment.bookingType === BookingTypeEnum.EXAM) {
		tagText = exam.tag;
	}

	return (
		<Container>
			<CardHeader>
				<Typography color="textPrimary" fontWeight={600}>
					{appointment.date.split(' ')[0]}
				</Typography>
				<Dot />
				<Typography color="textPrimary" fontWeight={600}>
					{appointment.hour}
				</Typography>
			</CardHeader>
			<CardContent>
				<Tag>{tagText}</Tag>
				<Stack direction="row" gap={1} alignItems="flex-start">
					<Icon name={isOdonto ? 'tooth-outline' : 'stethoscope'} />
					<Stack>
						<Typography color="textPrimary" fontWeight={600}>
							{formatText(
								isAdvanceDiagnosticsExam
									? appointment.specialtyName
									: appointment.providerName,
							)}
						</Typography>
						<Typography color="textSecondary">
							{isAdvanceDiagnosticsExam
								? selectedProcedure
								: formatText(appointment.specialtyName)}
						</Typography>
					</Stack>
					{hasFavoriteButton && (
						<FavoriteDoctorsLikeButton
							cdPrestador={Number(appointment.cdPrestador)}
							hideButton={hideFavoriteButton}
							cdEspecialidade={Number(appointment.specialtyCode)}
							cdSubEspecialidade={Number(appointment.subSpecialtyCode)}
							selected={appointment?.isFavorite}
							id={id}
							disabled={isFavoriteButtonDisabled}
							style={{marginLeft: 'auto'}}
							iconColor="#535862"
						/>
					)}
				</Stack>

				<Stack direction="row" gap={1} alignItems="flex-start">
					<Icon name="location-on-filled" />
					<Stack>
						<Typography color="textPrimary" fontWeight={600}>
							{formatText(clinicName)}
						</Typography>
						{isTelehealth && <AppointmentTeleTutorial />}
					</Stack>
				</Stack>

				<InstructionsAlertInfo
					bookingType={appointment.bookingType}
					specialtyCode={appointment.specialtyCode}
					specialtyName={appointment.specialtyName}
				/>
				{isUploadFileTeleFeatureFlagEnabled &&
				isTelehealth &&
				appointment?.acceptsAttachment ? (
					<AttachmentCard appointment={appointment} />
				) : null}

				<Divider sx={{margin: 'auto 0 0 0'}} />
			</CardContent>
			<StyledCardFooter>
				<CardActions appointment={appointment} showEnterRoom={showEnterRoom} />
			</StyledCardFooter>
		</Container>
	);
}
